/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaEnte } from '@models';

@Pipe({
    name: 'anagraficaEnte',
})
export class AnagraficaEntePipe implements PipeTransform {

    transform(value: number, items: AnagraficaEnte[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
